import axios, { AxiosError } from 'axios';

/**
 * Helper function to handle API errors consistently
 */
export const handleApiError = (error: unknown): Error => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError;
    const message =
      (axiosError.response?.data as { message?: string })?.message ||
      axiosError.message ||
      'An unknown error occurred';
    return new Error(message);
  }

  if (error instanceof Error) {
    return error;
  }

  return new Error('An unknown error occurred');
};
